import { Action, createReducer, on } from "@ngrx/store";
import * as LoginActionTypes from "../../actions/login/login.actions";
import * as UserActionTypes from "../../actions/users/user.actions";
import { UserSession } from "src/app/models/user-session";
import { UserLocaleDTO } from "src/app/models/UserDetails/userLocaleDTO";

export interface LoginState {
  currentUser?: UserSession;
  isAuthenticated: boolean;
  expirationDate: Date;
  error: Error;
  isLoading: boolean;
  showExpired: boolean;
  passwordRecovered: boolean;
  passwordReseted: boolean;
  localesList: UserLocaleDTO[];
  userProfile?: any
}

export const initialState: LoginState = {
  currentUser: null,
  isAuthenticated: false,
  expirationDate: null,
  error: null,
  isLoading: false,
  showExpired: false,
  passwordRecovered: false,
  passwordReseted: false,
  localesList: null,
  userProfile: null
};

const loginReducer = createReducer(
  initialState,
  on(LoginActionTypes.loginSuccess, (state, { authenticatedUser }) => ({
    ...state,
    isAuthenticated: true,
    error: null,
    isLoading: false,
    currentUser: authenticatedUser,
    expirationDate: new Date(
      new Date().getTime() + 1000 * authenticatedUser.expires_in
    ),
  })),
  on(LoginActionTypes.logOut, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(LoginActionTypes.logOutSuccess, (state) => ({
    ...state,
    currentUser: initialState.currentUser,
    isAuthenticated: initialState.isAuthenticated,
    error: initialState.error,
  })),
  on(LoginActionTypes.authenticate, (state, { user }) => ({
    ...state,
    isLoading: true,
  })),
  on(LoginActionTypes.loginFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error,
  })),
  on(LoginActionTypes.openExpired, (state) => ({
    ...state,
    showExpired: true,
  })),
  on(LoginActionTypes.closeExpired, (state) => ({
    ...state,
    showExpired: false,
  })),
  on(LoginActionTypes.recoverPassword, (state) => ({
    ...state,
    isLoading: true,
    passwordRecovered: false,
  })),
  on(LoginActionTypes.recoverPasswordSuccess, (state) => ({
    ...state,
    passwordRecovered: true,
  })),
  on(LoginActionTypes.resetPasswordSuccess, (state) => ({
    ...state,
    passwordReseted: true,
  })),
  on(LoginActionTypes.loadLocales, (state, { response }) => ({
    ...state,
    localesList: response.result.items || [],
    error: null,
  })),
  on(LoginActionTypes.setLoadingEndState, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(UserActionTypes.setLoggedUser, (state, { user }) => {
     return {
     ...state,
     userProfile: user?.result?.profile
   }
   })
);

export function reducer(state: LoginState | undefined, action: Action) {
  return loginReducer(state, action);
}
